export const MESSAGES = {
  SEND_CODE_ERROR: 'Une erreur est survenue lors de l’envoi du code de confirmation par mail',
  RECEIVE_CODE: 'Vous avez reçu le code de confirmation dans votre boite mail.',
  MISMATCH_CODE: 'Le code saisi est incorrect. Veuillez entrer le code reçu par mail.',
  LIMIT_EXCEEDED_CODE_ERROR: 'Vous avez généré trop de code, faites une pause, réessayez plus tard.',
  DEFAULT_ERROR: 'Une erreur est survenue, réessayez ultérieurement.',
  CONNEXION_ERROR: "Une erreur s'est produite lors de la connexion",
  EXPIRED_SESSION: 'Votre session a expiré, veuillez vous reconnecter.',
  NO_DATA_ERROR: 'Aucune donnée disponible.',
  DOWNLOAD_ERROR: 'Une erreur est survenu lors du téléchargement',
  STATUS_ERROR: 'Une erreur est survenu lors du changement de status',
  COMMENT_ERROR: "Une erreur est survenu lors de l'ajout du commentaire",
  SEND_MAIL_ERROR: "Une erreur est survenu lors de l'envoi du mail",
  RECONNECTION: 'Reconnexion en cours...',
  DELETE_ERROR: 'Une erreur est survenu lors de la suppression',
};
